export const QUIZ = [
  { q: "Le gengive sanguinano quando lavi i denti o usi il filo?", a: [["Mai", 0], ["A volte", 1], ["Spesso", 2]] },
  { q: "Le gengive ti sembrano gonfie, arrossate o ritirate, con denti che sembrano più lunghi?", a: [["No", 0], ["Un po'", 1], ["Sì", 2]] },
  { q: "Senti qualche dente che si muove o che si è spostato?", a: [["No", 0], ["Non saprei", 1], ["Sì", 3]], alarm: 2 },
  { q: "Ti capita di avere alito cattivo o un sapore sgradevole in bocca?", a: [["Raramente", 0], ["A volte", 1], ["Spesso", 2]] },
  { q: "Fumi, anche sigarette elettroniche o tabacco riscaldato?", a: [["No", 0], ["Ho smesso", 1], ["Sì", 2]] },
  { q: "Genitori o fratelli hanno perso denti per piorrea o parodontite?", a: [["No", 0], ["Non so", 1], ["Sì", 2]] },
  { q: "Hai il diabete?", a: [["No", 0], ["Non so", 1], ["Sì", 2]] },
  { q: "Quando hai fatto l'ultima igiene professionale?", a: [["Meno di 6 mesi fa", 0], ["Tra 6 e 12 mesi fa", 1], ["Più di un anno fa o non ricordo", 2]] },
];

export const RESULTS = {
  basso: {
    label: "Rischio basso",
    title: "Le tue gengive sembrano in buona salute.",
    text: "Dalle tue risposte non emergono segnali importanti. Per mantenerle così, la cosa migliore è un'igiene professionale delicata ogni 6 mesi e una buona pulizia quotidiana, anche tra i denti.",
    cta: { label: "Prenota l'igiene GBT", to: "/?trattamento=gbt#prenota" },
  },
  moderato: {
    label: "Rischio moderato",
    title: "Qualche segnale da non trascurare.",
    text: "Alcune risposte indicano che le gengive potrebbero essere infiammate. Spesso si tratta di una gengivite che, presa in tempo, si risolve bene. Una visita parodontale con sondaggio ti dirà con precisione come stanno le cose.",
    cta: { label: "Prenota la visita parodontale", to: "/prenota-visita-parodontale" },
  },
  elevato: {
    label: "Rischio elevato",
    title: "È il momento giusto per un controllo.",
    text: "Le tue risposte mostrano diversi segnali tipici della parodontite. Non spaventarti: prima si interviene, più denti naturali si riescono a salvare. Con il laser e il microscopio il percorso è delicato, e andiamo sempre al tuo ritmo.",
    cta: { label: "Prenota la visita parodontale", to: "/prenota-visita-parodontale" },
  },
};

export const resultFor = (answers) => {
  const score = answers.reduce((s, v) => s + v, 0);
  const alarm = QUIZ.some((x, i) => x.alarm !== undefined && answers[i] === x.a[x.alarm][1]);
  if (alarm || score >= 9) return "elevato";
  return score >= 4 ? "moderato" : "basso";
};
